import React from 'react';

import { RegistrationForm } from './patterns/RegistrationForm/RegistrationForm';
import DecisionStep from './patterns/DecisionStep/DecisionStep';
import ZipAddressStepWithSearch from './patterns/ZipAddressStep/ZipAddressStepWithSearch';
import BuroValidationOTP from './patterns/BuroValidationOTP/BuroValidationOTP';
import ContactDataRedirection from './patterns/ContactDataStep/ContactDataRedirection';
import CurpFeedback from './patterns/PersonalInfoStep/FeedbackExperiment/CurpFeedback';

/// ///////////////////////////////////////////////////////////////////////////////////////////
// THIS IS COMMENTED OUT BECAUSE WE ARE NOT USING IT, BUT WE KEEP IT HERE FOR REFERENCE //////
// ERASE THIS COMMENT WHEN WE ARE READY TO USE IT                                       /////
/// ///////////////////////////////////////////////////////////////////////////////////////

// const FINANCIAL_GOALS_EXPERIMENT_ID = '344539';
// const FINANCIAL_GOALS_EXPERIMENT_VARIANT = '46713';

// const REDIRECTION_SECOND_PHASE_RELAUNCH_EXPERIMENT_ID = '351299';
// const REDIRECTION_SECOND_PHASE_RELAUNCH_EXPERIMENT_VARIANT = '52546';

// const financialGoalsVariant = useFigPiiExperiment(FINANCIAL_GOALS_EXPERIMENT_ID);
// const redirectionVariant = useFigPiiExperiment(REDIRECTION_SECOND_PHASE_RELAUNCH_EXPERIMENT_ID);

// // Redirection Phase 2 Relaunch Experiment
// if (redirectionVariant === REDIRECTION_SECOND_PHASE_RELAUNCH_EXPERIMENT_VARIANT) {
//   return (
//     <RegistrationForm>
//       <ContactDataRedirection />
//       <CurpFeedbackRedirection />
//       <ZipAddressStepWithSearch shouldTriggerOTP />
//       <BuroValidationOTP />
//       <DecisionStep />
//     </RegistrationForm>
//   );
// }

// // Financial Goals Experiment
// if (financialGoalsVariant === FINANCIAL_GOALS_EXPERIMENT_VARIANT) {
//   return (
//     <RegistrationForm>
//       <ContactDataRedirection />
//       <CurpFeedback />
//       <ZipAddressStepWithSearch shouldTriggerOTP />
//       <BuroValidationOTP />
//       <FinancialGoals />
//       <DecisionStep activeFinancialGoals />
//     </RegistrationForm>
//   );
// }

const RegistrationFormWithCURP = () => (
  <RegistrationForm>
    <ContactDataRedirection />
    <CurpFeedback />
    <ZipAddressStepWithSearch />
    <BuroValidationOTP />
    <DecisionStep />
  </RegistrationForm>
);
export default RegistrationFormWithCURP;
